// extracted by mini-css-extract-plugin
var _1 = "title-AndCX";
export { _1 as "title" }
